import styled from 'styled-components'

export const LoadingWrapper = styled.div`
    text-align: center;
    margin: 50px auto;
    
    > div {
        color: var(--fai-text-color);
    }
`

export const LoadingTextWrapper = styled.div`
    text-align: center;
    margin: 50px 20px;
    font-size: 1.5rem;
`



// WEBPACK FOOTER //
// ./src/components/StyledComponents/Classifier/LoadingScreen.js